import styled from 'styled-components';
import { StyledBox } from '../../../components/styles/Grid/styles';

export const StyledRadioListWrapper = styled(StyledBox)`
  width: 100%;
  max-width: 17.125rem;
`;
